import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = 'memo'
const langValue = function () {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue
  })
  return obj
}

export default {
  id: 'textarea',
  name: 'textarea',
  type: 'action',
  moduleName: 'editor_module_textarea',
  dataSet: {
    mods: 'textarea',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'textarea',
        value: {
          label: ''
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'textarea',
      isRequired: true,
      label: langValue(),
      labelValue: defaultValue,
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
